// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { Logger, installConsoleFilter } from 'shared';
import { environment } from './environments/environment';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

Logger.configure(environment.debug);
installConsoleFilter();

const logger = new Logger('bootstrap');
logger.debug('bootstrapApplication > START');
bootstrapApplication(AppComponent, appConfig)
  .then(() => logger.debug('bootstrapApplication > COMPLETED'))
  .catch((error) => logger.error('bootstrapApplication', error));
